import ImageDoneStamp from '../../organisms/user_tutorial_completions/images/done_stamp.svg';
import { V3Routes } from '../../../routes';
import React, { useContext } from 'react';
import './userTutorialCard.module.scss';
import { userTutorialDetailTexts } from '../../atoms/user_tutorial/UserTutorialDetailTexts';
import { UserTutorialCompletionKey } from '../../../types/userTutorialCompletions';
import { UserTutorialCompletionContext } from '../../../contexts/userTutorialCompletion';
import { BodyText, LinkButton } from '@sheinc/shelikes-design-system';

type Props = {
  page_key: UserTutorialCompletionKey;
};

export const UserTutorialCard = ({ page_key }: Props) => {
  const pageContext = useContext(UserTutorialCompletionContext);
  const { resource } = pageContext;
  const hasCompleted = resource.hasCompleted(page_key);
  const { title } = userTutorialDetailTexts(page_key);
  const buttonType = hasCompleted ? 'secondary' : 'primary';
  const buttonText = hasCompleted ? 'もう一度見る' : '詳細を見る';
  return (
    <div styleName="tutorial-card-wrapper">
      <div styleName="tutorial-card" id={page_key}>
        {hasCompleted && <img id="completed-tutorial" src={ImageDoneStamp} styleName="card-stamp" />}
        <div styleName="tutorial-card-contents">
          <div styleName="tutorial-card-text">
            <BodyText weight="bold" align="center" lineHeight="tight">
              {title}
            </BodyText>
          </div>
          <div styleName="tutorial-card-action">
            <LinkButton to={V3Routes.userTutorialDetail(page_key)} variant={buttonType} size="small">
              {buttonText}
            </LinkButton>
          </div>
        </div>
      </div>
    </div>
  );
};
